var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',[(_vm.loading)?_c('b-spinner',{staticClass:"spinner",staticStyle:{"width":"5rem","height":"5rem"},attrs:{"label":"Large Spinner","type":"grow"}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }